module.exports = __webpack_public_path__ + "img/_starmap2.1b7a837a.png";